import { AlertOctagonIcon, RefreshCwIcon } from "lucide-react"
import { ReactNode } from "react"
import { Button } from "./ui/button"
import { Card, CardContent, CardHeader } from "./ui/card"

const ErrorMessage = (props: {
  children: ReactNode
  title?: string
  refresh?: boolean
  action?: ReactNode
}) => {
  return (
    <Card className="shadow-lg">
      <CardHeader>
        <h1 className="text-center text-2xl">
          {props.title ? props.title : "Ha ocurrido un error inesperado"}
        </h1>
      </CardHeader>

      <CardContent className="flex flex-col items-center justify-center gap-6">
        <AlertOctagonIcon size={92} className="text-amber-300" />

        <p className="text-center">{props.children}</p>

        {props.action}

        {props.refresh && (
          <Button onClick={() => window.location.reload()}>
            <RefreshCwIcon className="mr-3" />
            <span>Recargar</span>
          </Button>
        )}
      </CardContent>
    </Card>
  )
}

export { ErrorMessage }
